export default __webpack_public_path__ + "static/media/art-large.3d26fb7f.gif";